import Axios from '../baseApi';
export default {
  fetch(groupId, queryType) {
    return Axios.get(`/api-master-data/comment/v1/${groupId}?queryType=${queryType}`);
  },
  addOrUpdate(groupId, comment) {
    return Axios.post(`/api-master-data/comment/v1/${groupId}`, comment);
  },
  remove(commentId) {
    return Axios.delete(`/api-master-data/comment/v1/${commentId}`);
  },
}
